"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = exports.AuthRequireNewPassword = void 0;
var React = require("react");
var react_final_form_1 = require("react-final-form");
var react_intl_1 = require("react-intl");
var Validators_1 = require("../utils/Validators");
var chainAuthErrorMapping_1 = require("../utils/chainAuthErrorMapping");
function AuthRequireNewPassword(_a) {
    var authData = _a.authData, authState = _a.authState, onChangeState = _a.onChangeState, onCompleteNewPasswordRequired = _a.onCompleteNewPasswordRequired, Components = _a.Components;
    if (['requireNewPassword'].indexOf(authState) < 0) {
        return null;
    }
    var requiredAttributes = sort(authData.challengeParam.requiredAttributes);
    return (React.createElement(react_final_form_1.Form, { onSubmit: chainAuthErrorMapping_1.chainAuthErrorMapping(onCompleteNewPasswordRequired) }, function (_a) {
        var handleSubmit = _a.handleSubmit, submitting = _a.submitting, pristine = _a.pristine, hasValidationErrors = _a.hasValidationErrors, submitFailed = _a.submitFailed, dirtySinceLastSubmit = _a.dirtySinceLastSubmit, submitError = _a.submitError;
        return (React.createElement(Components.Wrapper, { footer: React.createElement(Components.ClickableText, { onClick: function () { return onChangeState('signIn'); } },
                React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.BACK_TO_SIGN_IN" })), header: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.CHANGE_PASSWORD" }, function (txt) { return React.createElement(Components.Headline, null, txt); }), loading: submitting },
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(react_final_form_1.Field, { autoComplete: "off", name: "password", component: Components.Input, type: "password", placeholder: "COGNITO_AUTH.NEW_PASSWORD", label: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.NEW_PASSWORD" }), required: true, validate: Validators_1.Validators.required }),
                React.createElement(react_final_form_1.Field, { autoComplete: "off", name: "passwordRepeat", component: Components.Input, type: "password", placeholder: "COGNITO_AUTH.NEW_PASSWORD_REPEAT", label: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.NEW_PASSWORD_REPEAT" }), required: true, validate: Validators_1.Validators.compose(Validators_1.Validators.required, Validators_1.Validators.equalTo('password', 'COGNITO_AUTH.PASSWORD')) }),
                requiredAttributes.map(function (attribute) { return (React.createElement(react_final_form_1.Field, { autoComplete: "off", key: attribute, name: attribute, component: Components.Input, type: "text", placeholder: "COGNITO_AUTH." + attribute.toUpperCase(), label: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH." + attribute.toUpperCase() }), required: true, validate: Validators_1.Validators.required })); }),
                React.createElement(Components.ErrorMessage, { message: submitError }),
                React.createElement(Components.Button, { type: "submit", disabled: submitting ||
                        pristine ||
                        hasValidationErrors ||
                        (submitFailed && !dirtySinceLastSubmit) },
                    React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.CHANGE" })))));
    }));
}
exports.AuthRequireNewPassword = AuthRequireNewPassword;
function sort(arr) {
    return __spreadArrays(arr).sort(function (a, b) {
        var ordered = ['given_name', 'family_name'];
        var indexA = ordered.indexOf(a);
        var indexB = ordered.indexOf(b);
        if (indexA > -1 && indexB > -1) {
            return indexA - indexB;
        }
        if (indexA > -1) {
            return -1;
        }
        if (indexB > -1) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        if (a > b) {
            return 1;
        }
        return 0;
    });
}
exports.sort = sort;
//# sourceMappingURL=AuthRequireNewPassword.js.map